
export const sortStrings = function (arrayOfStrings) {
  const arrayOfLowerCaseStrings = arrayOfStrings.map(e => {
    return {
      original: e,
      lower: e.toLowerCase()
    }
  })
  arrayOfLowerCaseStrings.sort(function (a, b) {
    if (a.lower > b.lower) {
      return 1
    } else if (a.lower === b.lower) {
      return 0
    } else {
      return -1
    }
  })
  return arrayOfLowerCaseStrings.map(e => e.original)
}



// WEBPACK FOOTER //
// ./src/app/common/U_SORT.js